module.exports = __webpack_public_path__ + "static/media/WXRWYR3.3a93d8a7.png";